import Vue from 'vue'
import VueRouter from 'vue-router'
/* import Horas from "@/components/Horas"; */
import store from '../store/'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Reserva',
		component: () => import(/* webpackChunkName: "about" */ '../components/Horas/Reserva.vue'),
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import(/* webpackChunkName: "about" */ '../components/Login/index.vue')
	},
	{
		path: '/register',
		name: 'Register',
		component: () => import(/* webpackChunkName: "about" */ '../components/Register/index.vue')
	},
	{
		path: '/forgot-password',
		name: 'ForgotPassword',
		component: () => import(/* webpackChunkName: "about" */ '../components/forgotPassword/index.vue')
	},
	{
		path: '/reset-password-valid-token',
		name: 'ResetPassword',
		component: () => import('../components/ResetPassword/index.vue')
	},
	{
		path: '/estado-pago',
		name: 'EstadoPago',
		component: () => import('../components/EstadoPago/EstadoPago.vue')
	},
	{
		path: '/categorias',
		name: 'Especialidades',
		component: () => import(/* webpackChunkName: "about" */ '../components/Especialidades/index.vue'),
	},
	{
		path: '/categoria',
		name: 'Medicos',
		component: () => import(/* webpackChunkName: "about" */ '../components/Medicos/index.vue'),
	},
	{
		path: '/horarios/:id',
		name: 'Horarios',
		component: () => import(/* webpackChunkName: "about" */ '../components/Horarios/index.vue'),
	},
	{
		path: '/agenda/:id',
		name: 'Agenda',
		component: () => import(/* webpackChunkName: "about" */ '../components/Agenda/index.vue'),
	},
	{
		path: '/ficha/:id',
		name: 'Ficha',
		component: () => import(/* webpackChunkName: "about" */ '../components/Ficha/index.vue'),
	},
	{
		path: '/fichas',
		name: 'RegistroFichas',
		component: () => import(/* webpackChunkName: "about" */ '../components/RegistroFichas/index.vue'),
	},
	{
		path: '/usuarios',
		name: 'Usuarios',
		component: () => import(/* webpackChunkName: "about" */ '../components/Usuarios/index.vue'),
	},
	{
		path: '/confirmacion',
		name: 'Cita',
		component: () => import(/* webpackChunkName: "about" */ '../components/Cita/index.vue'),
	},
	{
		path: '/configuracion',
		name: 'Configuracion',
		component: () => import('../components/Configuracion/index.vue'),
	},
	{
		path: '/atenciones/:id',
		name: 'Atenciones',
		component: () => import(/* webpackChunkName: "about" */ '../components/Atenciones/index.vue'),
	},
	{
		path: '/reserva',
		name: 'Reserva2',
		component: () => import(/* webpackChunkName: "about" */ '../components/Horas/Reserva.vue'),
	},
	{
		path: '/PanelSocketVideo',
		name: 'NuevoSocketVideo',
		component: () => import(/* webpackChunkName: "about" */ '../components/SocketVideo/NuevoSocketVideo.vue'),
	},
	{
		path: '/videocall',
		name: 'Videocall',
		component: () => import(/* webpackChunkName: "about" */ '../components/RemoteAttention/RemoteAttention.vue'),
	},
	{
		path: '/:id',
		name: 'Redirect',
		component: () => import(/* webpackChunkName: "about" */ '../components/Redirect/Redirect.vue'),
	},

//	404 redirect to home
	{
		path: '*',
		redirect: '/'
	}
]

const router = new VueRouter({
	mode: 'history',
	scrollBehavior: () => ({y: 0}),
	routes
})

router.beforeEach((to, from, next) => {
	const currentId = to.query.id;
	const reservation_id = to.query.reservation_id;
	console.log(to);
	if (to.name !== 'Cookie' && to.name !== 'Login'   && to.name !== 'Register' && to.name !== 'ForgotPassword' && to.name !== 'ResetPassword' && to.name !== 'EstadoPago' && !store.state.isAuthenticated) next({ name: 'Login', query: { redirect_to: to.path, reservation_id } });
	else if ((to.name === 'Login') && store.state.isAuthenticated) next({ name: 'Home' })
	else next()
})

export default router
